import { isValidPhoneNumber } from 'react-phone-number-input';

import { OnboardingFormData } from '../../defaultFormData';

import { validateEmail } from '@/utils/stringValidators';

const validateCaregiverInfoForm = (
  onboardingFormData: Partial<OnboardingFormData>,
): boolean => onboardingFormData.caregiverFirstName !== ''
        && onboardingFormData.caregiverLastName !== ''
        && validateEmail(onboardingFormData.caregiverEmail)
        && isValidPhoneNumber(onboardingFormData.caregiverPhoneNumber)
        && onboardingFormData.safetyAcknowledgement === true
        && onboardingFormData.policyAndTermsAcknowledgement === true;

export default validateCaregiverInfoForm;
